module.exports = __webpack_public_path__ + "static/FacebookShare-00082641824305d308c79337d09154b1.png";